import React from "react";
import Footer from "../components/footer";
import Seo from '../components/Seo';

export default function PrivacyPolicy() {
  return (
    <main
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      <Seo title="Polityka prywatności" path="/polityka-prywatnosci" noindex />
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          padding: "140px 40px 60px 40px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          gap: "28px",
        }}
      >
        <h1
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "38px",
            fontWeight: "700",
            color: "rgb(30,30,30)",
            margin: 0,
            letterSpacing: "-0.5px",
          }}
        >
          POLITYKA PRYWATNOŚCI
        </h1>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            color: "rgb(40,40,40)",
            fontSize: "17px",
            lineHeight: "1.7",
          }}
        >
          <section>
            <h2 style={headingStyle}>1. Administratorem danych jest:</h2>
            <p style={textStyle}>
              jest Fundacja 4STARS Dance &amp; Aerial Studio z siedzibą we
              Wrocławiu przy ul. Tkacka 14/2, NIP: 8943217579, KRS: 0001052268
              (zwana dalej „Firmą”).
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>2.</h2>
            <p style={textStyle}>
              Podanie jakichkolwiek danych osobowych ma charakter dobrowolny,
              jednakże jest to konieczne do osiągnięcia celu lub podjęcia
              działań związanych z ich podaniem.
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>
              3. Administrator przetwarza następujące dane Klienta:
            </h2>
            <div style={textStyle}>
              <div>a) nazwisko i imiona,</div>
              <div>b) adres e-mail,</div>
              <div>c) telefon,</div>
              <div>d) numer PESEL,</div>
              <div>e) adres zamieszkania i kod pocztowy,</div>
              <div>f) wiek,</div>
              <div>g) aktywność względem poszczególnych projektów,</div>
              <div>
                h) aktywność względem korzystania z poszczególnych usług,
              </div>
              <div>
                i) niezbędne dane zdrowotne związane z realizacją usługi,
              </div>
              <div>
                j) dane osobowe lub informacje do których poboru jesteśmy
                zobligowani na mocy obowiązujących aktów prawnych, zaleceń lub
                wytycznych
              </div>
            </div>

            <p style={{ ...textStyle, marginTop: "14px" }}>
              W przypadku, gdy uczestnikiem usługi są dzieci, przetwarzane są
              dane zarówno ich, jak i ich rodziców. Administrator przetwarza
              również adres e-mail, telefon oraz imię odbiorcy newslettera. Dla
              pracowników zespół przetwarzanych danych wynika z przepisów
              kadrowych.
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>4.</h2>
            <p style={textStyle}>
              Na podstawie art. 6 Rozporządzenia Parlamentu Europejskiego i Rady
              (UE) 2016/679 z 27.04.2016 r. w sprawie ochrony osób fizycznych w
              związku z przetwarzaniem danych osobowych i w sprawie swobodnego
              przepływa takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne
              rozporządzenie o ochronie danych) - RODO, podstawą przetwarzania
              danych osobowych przez Administratora jest zgoda Użytkowników,
              prawny obowiązek oraz realizację umowy.
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>5. Cele przetwarzania danych</h2>
            <div style={textStyle}>
              <div>
                a) sprzedaż Usług i produktów będących przedmiotem oferty (art.
                6 ust. 1 lit. b RODO),
              </div>
              <div>
                b) należyte wykonywanie umów zawartych z Fundacją 4STARS Dance
                &amp; Aerial Studio (art. 6 ust. 1 lit. b RODO),
              </div>
              <div>
                c) doręczanie mailingów informacyjnych i reklamowych, na które
                wyraził zgodę użytkownik (art. 6 ust. 1 lit. a RODO),
              </div>
              <div>
                d) organizowanie wyjazdów, warsztatów, konferencji, spotkań,
                eventów sportowych i edukacyjnych (art. 6 ust. 1 lit. b RODO),
              </div>
              <div>
                e) organizacja zajęć sportowych (art. 6 ust. 1 lit. b RODO),
              </div>
              <div>f) działalność związana ze sportem i zdrowym trybem życia,</div>
              <div>
                g) zapewnienie bezpieczeństwa zdrowotnego klientów oraz
                pracowników,
              </div>
              <div>
                h) stała komunikacja informacyjna, edukacyjna i reklamowa z
                odbiorcami,
              </div>
            </div>
          </section>

          <section>
            <h2 style={headingStyle}>6. Do danych osobowych mają dostęp</h2>
            <p style={textStyle}>
              wszyscy członkowie zespołu Firmy. Dostępy do poszczególnych
              kategorii osób rozdzielone są poprzez ograniczenie uprawnień
              technicznych wejścia do wspólnego dysku lub folderu. Na podobnej
              zasadzie, dokumenty są również zabezpieczone fizycznie w szafkach
              zamykanych na klucz. Lista podmiotów zewnętrznych, które mają
              dostęp do danych osobowych znajduje się tutaj:
              https://4starsdanceaerialstudio.pl/wp-content/uploads/2023/11/Polityki-Prywatnosci-Firmy-zewnetrzne.pdf
            </p>

            <p style={textStyle}>
              Polityka prywatności każdego z tych podmiotów mieści się na ich
              stronach podanych w powyższym linku.
            </p>

            <p style={textStyle}>
              Powyższe podmioty gwarantują przestrzeganie Rozporządzenia lub
              przestrzeganie analogicznych do Rozporządzenia standardów w
              zakresie ochrony danych osobowych, a korzystanie przez
              Administratora z ich technologii przy przetwarzaniu danych
              osobowych jest zgodne z prawem. Z podmiotami zawarte zostały
              umowy powierzenia, przeważnie w formie aktualizacji ich
              regulaminów.
            </p>

            <p style={textStyle}>
              Administrator nie będzie sprzedawać ani przekazywać danych
              osobowych Klientów innym podmiotom innym niż podanym w linku.
            </p>

            <p style={textStyle}>
              Użytkownik przyjmuje do wiadomości, iż jego dane osobowe mogą być
              przekazywane uprawnionym organom państwowym w związku z
              prowadzonymi przez nie postępowaniami, na ich żądanie i po
              spełnieniu przesłanek potwierdzających niezbędność pozyskania od
              nas tych danych.
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>
              7. Użytkownik korzysta z następujących praw:
            </h2>
            <div style={textStyle}>
              <div>
                a) Prawo do cofnięcia zgody – cofnięcie zgody może jednak
                uniemożliwić dalsze korzystanie z usług, które zgodnie z prawem
                Administrator świadczyć może jedynie za zgodą. Ponadto cofnięcie
                zgody nie powoduje, że przetwarzanie danych osobowych do momentu
                cofnięcia było niezgodne z prawem.
              </div>

              <div style={{ marginTop: "10px" }}>
                b) Prawo do sprzeciwu wobec wykorzystania danych – jeśli
                Administrator przetwarza dane w oparciu o prawnie uzasadniony
                interes, Czytelnik może wnieść sprzeciw wobec ich
                wykorzystywania. Jeżeli sprzeciw okaże się zasadny, a
                Administrator nie będzie mieć innej podstawy prawnej do
                przetwarzania danych – usunie dane będące przedmiotem sprzeciwu.
              </div>

              <div style={{ marginTop: "10px" }}>
                c) Prawo do usunięcia danych („prawo do bycia zapomnianym”) –
                Administrator na żądanie usunie dane w przypadku wycofania
                zgody, wniesienia zasadnego sprzeciwu wobec wykorzystania w
                celach marketingowych lub statystycznych, przetwarzania
                niezgodnie z prawem lub gdy przestały być niezbędne do celów, w
                których zostały zebrane lub w których były przetwarzane.
                Administrator zastrzega, że może zachować pewne dane osobowe w
                zakresie niezbędnym do kopii zapasowych lub celów ustalenia,
                dochodzenia lub obrony roszczeń oraz relacji z organami
                państwowymi.
              </div>

              <div style={{ marginTop: "10px" }}>
                d) Prawo do ograniczenia przetwarzania danych – w przypadku
                kwestionowania prawidłowości danych oraz legalności lub
                niezbędności ich przetwarzania i wniesienia sprzeciwu.
              </div>

              <div style={{ marginTop: "10px" }}>
                e) Prawo dostępu do danych – Administrator zobowiązuje się do
                potwierdzenia przetwarzania danych osobowych, jeśli ma ono
                miejsce. W takim przypadku Użytkownik ma możliwość uzyskania
                kopii danych i dostępu do nich oraz uzyskania informacji
                zawartych w niniejszej Polityce i innych żądanych.
              </div>

              <div style={{ marginTop: "10px" }}>
                f) Prawo do sprostowania danych – Administrator na żądanie
                Użytkownika lub Klienta zobowiązuje się do sprostowania danych
                (dla danych nieprawidłowych) oraz ich uzupełnienia (dla danych
                niekompletnych).
              </div>

              <div style={{ marginTop: "10px" }}>
                g) Prawo do przenoszenia danych – na żądanie użytkownika lub
                Klienta Administrator wyśle, w postaci pliku w formacie pdf lub
                innym ustalonym, dane osobowe do żądającego lub bezpośrednio do
                innego wskazanego przez niego Administratora.
              </div>

              <div style={{ marginTop: "10px" }}>
                h) Ponadto Użytkownik ma prawo do wniesienia skargi do Prezesa
                Urzędu Ochrony Danych Osobowych.
              </div>
            </div>

            <p style={{ ...textStyle, marginTop: "14px" }}>
              Administrator zapewnia realizację uprawnień poprzez napisanie
              maila na adres biuro@szkola4stars.pl, określając
              czytelnie, w tytule, z jakiego prawa Użytkownik chce skorzystać.
            </p>

            <p
              style={{
                ...textStyle,
                marginTop: "8px",
                textDecoration: "line-through",
              }}
            >
              Administrator po otrzymaniu wiadomości w ciągu 30 dni zrealizuje
              żądanie.
            </p>
          </section>

          <section>
            <h2 style={headingStyle}>8. Przechowywanie danych</h2>
            <p style={textStyle}>
              a) Okres przechowywania danych, nie będzie krótszy, aniżeli
              wynika z obowiązujących przepisów prawa (z ustaw szczególnych)
              tj. m.in.: ustawy o rachunkowości, ordynacji podatkowej, ustawy o
              emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, czy
              ustawy o systemie ubezpieczeń społecznych. b) Dane odbiorców
              newslettera przechowywane będą do wniosku o ich usunięcie, c)
              Dane Klientów przechowywane będą do upływu okresu przedawnienia
              roszczeń z ich tytułu.
            </p>

            <p style={textStyle}>
              Firma zobowiązuje się do niszczenia powstałych tymczasowo
              dokumentów zawierających dane osobowe (np. Lista uczestników
              konkretnego eventu lub zajęć) oraz dbałości o obieg danych i ich
              minimalizację zgodnie z procedurami zapisanymi w Rejestrze
              Czynności Przetwarzania.
            </p>

            <p style={textStyle}>
              Administrator stosuje środki techniczne i organizacyjne
              zapewniające ochronę przetwarzanych danych osobowych odpowiednią
              do zagrożeń oraz kategorii danych objętych ochroną, a w
              szczególności zabezpiecza dane przed ich udostępnieniem osobom
              nieupoważnionym, zabraniem przez osobę nieuprawnioną,
              przetwarzaniem z naruszeniem obowiązujących przepisów oraz zmianą,
              utratą, uszkodzeniem lub zniszczeniem.
            </p>

            <p style={textStyle}>
              Administrator Danych Osobowych niniejszym informuje, że nie
              powołał Inspektora Ochrony Danych (IOD) i wykonuje samodzielnie
              obowiązki związane z przetwarzaniem danych osobowych.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </main>
  );
}

const headingStyle = {
  fontSize: "28px",
  fontWeight: "700",
  color: "rgb(25,25,25)",
  margin: "0 0 8px 0",
};

const textStyle = {
  fontSize: "17px",
  color: "rgb(50,50,50)",
  lineHeight: "1.7",
  margin: 0,
};